import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const Laixetable = React.memo(function Laixetable(props) {
  const classes = useStyles();
  const { laixe } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th_dn}>stt</th>
          <th className={classes.tablebc_th_dn}>Họ tên</th>
          <th className={classes.tablebc_th_dn}>Ngày sinh</th>
          <th className={classes.tablebc_th_dn}>CMND/CCCD</th>
          <th className={classes.tablebc_th_dn}>Địa chỉ</th>
          <th className={classes.tablebc_th_dn}>Số GPLX</th>
          <th className={classes.tablebc_th_dn}>Hạng GPLX</th>
          <th className={classes.tablebc_th_dn}>Ngày hết hạn</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        {laixe.map((row, i) => {
          return (
            <tr key={i}>
              <td className={classes.tablesotan_td}>{row["stt"]}</td>
              <td className={classes.tablesotan_td}>{row["hoten"]}</td>
              <td className={classes.tablesotan_td}>{row["ngaysinh"]}</td>
              <td className={classes.tablesotan_td}>{row["cmnd"]}</td>
              <td className={classes.tablesotan_td}>{row["diachi"]}</td>
              <td className={classes.tablesotan_td}>
                {row["sogiaypheplaixe"]}
              </td>
              <td className={classes.tablesotan_td}>
                {row["hanggiaypheplaixe"]}
              </td>
              <td className={classes.tablesotan_td}>{row["ngayhethangplx"]}</td>
            </tr>
          );
        })}
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div className={classes.table}>
      <table className={classes.tablebc} style={{ height: "450px" }}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

Laixetable.propTypes = {
  laixe: PropTypes.array,
};
export default Laixetable;
